import { useFormContext } from "react-hook-form";

import { TextFieldProps } from "@mui/material";

import { RoofShape } from "@covertree/new-business-graphql";
import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormSelectableWithImageAndDescription } from "@covertree/types";
import {
  buildSelectableOptionsWithImageAndDescription,
  FormSelectField,
} from "@covertree/ui";

import {
  HomeDetailsForm,
  roofShapes,
} from "../validatorsAndTypes/homeDetailsAndConstructionForm";

export const roofTypes: Record<
  RoofShape,
  FormSelectableWithImageAndDescription | undefined
> = {
  [RoofShape.Gable]: {
    name: "Gable",
    image: "/images/roof-types/gable.png",
    description:
      "The roof consists of two, opposite sloping roof sections that meet at the highest point.",
  },
  [RoofShape.Hip]: {
    name: "Hip",
    image: "/images/roof-types/hip.png",
    description:
      "This roof consists usually of four sloping roof sections that meet at a single point or ridge.",
  },
  [RoofShape.Flat]: {
    name: "Flat",
    image: "/images/roof-types/flat.png",
    description: "This roof is very low pitched (3 in 12 or less).",
  },
  [RoofShape.BowedCurvedArched]: {
    name: "Bowed/Curved/Arched",
    image: "/images/roof-types/curved.png",
    description:
      "This roof is curved rather than using a straight lines for the slope.",
  },
  [RoofShape.Shed]: {
    name: "Shed",
    image: "/images/roof-types/shed.png",
    description: "This roof consists of a single sloping roof section.",
  },
  [RoofShape.NotListed]: undefined,
};

type Props = Omit<TextFieldProps, "variant"> & {
  name?: string; // @TODO investigate why "Path" from "react-hook-form" type is not working
  label?: React.ReactNode;
  placeholder?: string;
  fontSize?: number;
  labelFontSize?: number;
};

const definitions = buildSelectableOptionsWithImageAndDescription(roofTypes);

export function RoofShapesSelect({
  name = "roofShape",
  label = "Roof Shape",
  placeholder = "Select ...",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { roofShape } = useNewBusinessSelector(selectBasicQuestions);

  const { control } = useFormContext<HomeDetailsForm>();

  return (
    <FormSelectField
      id="shape"
      dataTestId="roof-shape-input"
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      name={name as any}
      label={roofShape?.label ?? label}
      placeholder={placeholder}
      control={control}
      options={roofShapes}
      definition={definitions}
      disabled={disabled}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
    />
  );
}
